var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83329 14.7155V16.6667C7.83329 17.5871 8.57949 18.3333 9.49996 18.3333C10.4204 18.3333 11.1666 17.5871 11.1666 16.6667V14.7155M9.49996 1.66666V2.49999M1.99996 9.99999H1.16663M4.08329 4.58332L3.58321 4.08324M14.9166 4.58332L15.4168 4.08324M17.8333 9.99999H17M14.5 9.99999C14.5 12.7614 12.2614 15 9.49996 15C6.73854 15 4.49996 12.7614 4.49996 9.99999C4.49996 7.23857 6.73854 4.99999 9.49996 4.99999C12.2614 4.99999 14.5 7.23857 14.5 9.99999Z",
    stroke: "#071B22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityBulb);
export default __webpack_public_path__ + "static/media/ActivityBulb.9aca09c082937eec0f6544f37c4db2ca.svg";
export { ForwardRef as ReactComponent };